const MARKERS_CONFIG = {
  size: 6,
  shape: 'circle',
};

export default class MarkersConfigBuilder {
  #config = { ...MARKERS_CONFIG };

  build() {
    return this.#config;
  }
}
